import { Component, prop } from "@kluntje/core";
import { autobind } from "Helper/functionHelper/decorators";

class FraTimePickerField extends Component {
  // used to access selected value from other components
  static value = "";
  /*
   * return time string. In this case get current time and convert to string
   * Round down the minutes to the nearest multiple of 15
   */
  static timeString() {
    const date = new Date();

    const hour = String(date.getHours()).padStart(2, "0");

    const min = date.getMinutes();
    const roundDown = Math.floor(min / 15) * 15;
    const minute = String(roundDown).padStart(2, "0");

    return `${hour}:${minute}`;
  }

  /*
   * Format time value
   */
  static formatTimeString(val: string): any {
    const date = new Date(val);
    if (isNaN(date.getTime())) return val;

    return `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
  }

  /*
   * Normalize a value by replacing "{NOW}" or "{TODAY}" with the current time
   */
  static normalizeValue(val: string) {
    if (/^\{(?<keyword>NOW|TODAY)/.test(val)) {
      val = FraTimePickerField.timeString();
    }

    return val;
  }

  /*
   * label used for mobile view in the dialog
   */
  @prop({ required: true })
  timeLabel = "";

  /*
   * Get the value attribute of the time picker field
   */
  get value() {
    return this.getAttribute("value") || "";
  }

  set value(val) {
    if (val === undefined || val === null) this.removeAttribute("value");
    else {
      val = FraTimePickerField.formatTimeString(val);
      this.setAttribute("value", val);
      this.displayValue = val;
      FraTimePickerField.value = val;
    }
  }

  get iconID() {
    return this.getAttribute("iconId") || "";
  }

  /*
   * Get the closest parent form element when included inside a form
   */
  get form() {
    return this.closest("form");
  }

  /*
   * Get the displayed value of the time picker field
   */
  get displayValue() {
    return this.innerText;
  }

  set displayValue(value: string) {
    this.innerText = value;
  }

  /*
   * Perform operations after the component has been rendered
   */
  afterComponentRender() {
    this.value = FraTimePickerField.normalizeValue(this.value);
    if (sessionStorage.getItem("restoreFlightOverview")) {
      this.handleSearchRestoreTime(JSON.parse(sessionStorage.getItem("restoreFlightOverview")!));
    }

    if (this.form) this.form.addEventListener("formdata", this.handleFormData);
  }

  /*
   * use session storage to restore time
   */
  handleSearchRestoreTime(restoreObject: any): void {
    const hour = String(new Date(restoreObject.formData.time).getHours()).padStart(2, "0");
    const minutes = String(new Date(restoreObject.formData.time).getMinutes()).padStart(2, "0");
    this.value = `${hour}:${minutes}`;
  }

  /*
   * Perform operations like inject time values into the form before it is disconnected
   */
  beforeComponentDisconnects() {
    if (this.form) this.form.removeEventListener("formdata", this.handleFormData);
  }

  @autobind
  handleFormData({ formData }: FormDataEvent) {
    if (this.disabled) return;
    // Inject date/time values into the form data
    Object.entries(this.getFormValues()).forEach(([key, value]) => {
      formData.set(key, value);
    });
  }

  getFormValues() {
    const result: { [key: string]: string } = {};
    result[this.formFieldName] = this.value;

    return result;
  }
}

customElements.define("fra-e-time-picker__field", FraTimePickerField);

export default FraTimePickerField;
